function resolveBaseUrl(raw: string): string {
  const trimmed = (raw || '').replace(/\/$/, '');
  if (!trimmed) return '';
  if (trimmed.startsWith('/')) {
    return `${window.location.origin}${trimmed}`;
  }
  return trimmed;
}

export const apiBaseUrl = resolveBaseUrl(import.meta.env.VITE_API_BASE_URL ?? '');
export const skipAuth = import.meta.env.VITE_SKIP_AUTH === 'true';
/** API geode `location` for geode_hit (demo = DEMO, live game = Booga Town). */
export const defaultLevel = import.meta.env.VITE_DEFAULT_LEVEL || 'DEMO';

export function isBackendEnabled() {
  return Boolean(apiBaseUrl) && !skipAuth;
}

export function authBypassed() {
  return skipAuth || !apiBaseUrl;
}
